import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'app/_services/notification.service';
import { ScheduleValidationService } from 'app/_services/schedule-validation.service';
import { SiteWorkOrdersService } from 'app/_services/site-work-orders.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'edit-schedule-modal',
  templateUrl: './edit-schedule-modal.component.html',
})
export class EditScheduleModalComponent implements OnInit {
  @Input() workOrder: any;

  public form: FormGroup;
  public validationErrors: any[] = [];
  public minDate = new Date();
  public saveInProgress = false;

  constructor(
    private activeModal: NgbActiveModal,
    private notificationService: NotificationService,
    private workOrderService: SiteWorkOrdersService,
    private scheduleValidationService: ScheduleValidationService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.minDate.setUTCHours(0,0,0,0);
    let startDate = this.workOrder.scheduledStartTime ? new Date(this.workOrder.scheduledStartTime) : undefined;
    let endDate = this.workOrder.scheduledEndTime ? new Date(this.workOrder.scheduledEndTime) : undefined;

    this.form = this.formBuilder.group({
      scheduledStartTime: new FormControl(startDate),
      scheduledEndTime: new FormControl(endDate),
    });
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public onSubmit() {
    this.saveInProgress = true;
    const values = this.form.value;

    this.validationErrors = [];
    const validation = this.scheduleValidationService.validateForm(values);

    if (!validation.isValid) {
      this.validationErrors = validation.validationErrors;
      this.saveInProgress = false;
      return
    }

    const body = {
      scheduledStartTime: values.scheduledStartTime,
      scheduledEndTime: values.scheduledEndTime,
      // required for the PUT Request:
      id: this.workOrder.id,
      description: this.workOrder.description,
      released: this.workOrder.released,
      approvalStatus: this.workOrder.approvalStatus,
      minimumPartySize: this.workOrder.minimumPartySize,
      checkOnSiteFormId: this.workOrder.checkOnSiteFormId,
      checkOffSiteFormId: this.workOrder.checkOffSiteFormId,
      exemptFromAssetScheduling: this.workOrder.exemptFromAssetScheduling,
    };

    this.workOrderService.updateWorkOrder(body).subscribe(() => {
      Swal.fire('Updated!', 'Work Order has been updated.', 'success');
      this.activeModal.close('refresh');
    }, error => {
      let message = 'Schedule could not be saved';
      if (error && error.error && error.error.fieldErrors && error.error.fieldErrors[0] && error.error.fieldErrors[0].message) {
        message = error.error.fieldErrors[0].message;
      }

      this.notificationService.notify('danger', 'Error', message);
      this.saveInProgress = false;
    });
  }
}
